import { ComponentStatus } from '@cast/types-cluster-management';

export const generateClusterManagementComponentStatus = (
  mockComponentStatus: Partial<ComponentStatus> = {}
): ComponentStatus => {
  return {
    installedComponentId: undefined,
    status: 'STATUS_UNSPECIFIED',
    ...mockComponentStatus,
  };
};
